<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <form-select v-if="!client" :model="filterFormModel" attribute="group" class="mr-1" :options="[
                    {value: 'day', text: $t('byDay')},
                    {value: 'month', text: $t('byMonth')},
                    {value: 'client', text: $t('byClient')},
                    {value: 'category', text: $t('byCategory')},
                    {value: 'plan', text: $t('byPlan')},
                    ]"></form-select>
          <form-select v-if="!client" :model="filterFormModel" attribute="source" class="mr-1" :options="[
                    {value: null, text: $t('clientSource')},
                    {value: 'nature', text: $t('nature')},
                    {value: 'sales', text: $t('salesFound')},
                    {value: 'mkt', text: 'Marketing'}
                    ]"></form-select>
          <client-select :model="filterFormModel"  attribute="client" @input="load" :isFilter="true" :place-holder="$t('selectClient') "
                         v-if="filterFormModel.group === 'day' && !client" class="mr-1"></client-select>
          <time-range-picker :model="filterFormModel" @input="load" :label="$t('time')" :default-shortcut="6" class="mr-1"></time-range-picker>
          <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
          <button @click="reset" class="btn btn-secondary mr-1">Reset</button>
          <finance-export :data="data" :sum="sum" :avg="avg" :label="label"
                          v-if="['admin', 'owner', 'tech', 'account', 'operationsManager', 'salesAssistant', 'accountant'].includes($store.state.user.role)"></finance-export>
        </div>
      </div>
      <template v-if="!client">
        <div class="tile">
          <div class="table-responsive c-template-table">
            <table class="table table-hover table-bordered">
              <thead>
              <tr>
                <th rowspan="2"></th>
                <th class="text-center" colspan="4">{{ $t('moneyIn') }}</th>
                <th class="text-center" colspan="31">{{ $t('expense') }}</th>
              </tr>
              <tr>
                <th class="text-center">{{ $t('deposit') }}</th>
                <th class="text-center">{{ $t('gift') }}</th>
                <th class="text-center">{{ $t('affiliate') }}</th>
                <th class="text-center">{{ $t('claim') }}</th>
                <th class="text-center">{{ $t('receive') }}</th>
                <th class="text-center">{{ $t('call') }}</th>
                <th class="text-center">{{ $t('callPackage') }}</th>
                <th class="text-center">{{ $t('cdp') }}</th>
                <th class="text-center">{{ $t('invoicePlanOrder') }}</th>
                <th class="text-center">Email</th>
                <th class="text-center">SMS</th>
                <th class="text-center">ZNS</th>
                <th class="text-center">{{ $t('aiChatbot') }}</th>
                <th class="text-center">Speech to text</th>
                <th class="text-center">{{ $t('financeAiAgentToken') }}</th>
                <th class="text-center">{{ $t('financeConvEval') }}</th>
                <th class="text-center">Viber</th>
                <th class="text-center">{{ $t('sendOAMessage') }}</th>
                <th class="text-center">Line</th>
                <th class="text-center">{{ $t('ccuPackage') }}</th>
                <th class="text-center">{{ $t('number') }}</th>
                <th class="text-center">{{ $t('setup') }}</th>
                <th class="text-center">{{ $t('brandName') }}</th>
                <th class="text-center">{{ $t('brandNameRegister') }}</th>
                <th class="text-center">{{ $t('new') }}</th>
                <th class="text-center">{{ $t('newDivide') }}</th>
                <th class="text-center">{{ $t('upgrade') }}</th>
                <th class="text-center">{{ $t('extend') }}</th>
                <th class="text-center">{{ $t('user') }}</th>
                <th class="text-center">{{ $t('refund') }}</th>
                <th class="text-center">{{ $t('callRefund') }}</th>
                <th class="text-center">{{ $t('smsRefund') }}</th>
                <th class="text-center">{{ $t('send') }}</th>
                <th class="text-center">{{ $t('financeOther') }}</th>
                <th class="text-center">{{ $t('totals') }} {{ $t('expense') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr class="bg-success">
                <td><b class="text-uppercase">{{ $t('totals') }}</b></td>
                <td class="text-center"><span class="text-blue">{{ sum.deposit | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.gift | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.affiliate | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.claim | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.receive | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.call | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.callPackage | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.cdp | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.invoicePlanOrder | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.email | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.sms  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.zns  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.aiChatbot  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.callTranscript  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.aiAgentToken  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.conversationEval  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.viber  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.oa  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.linePackage  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.ccuPackage  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.number | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.setup | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.brandName | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.brandNameRegister | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.new | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.newDivide | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.upgrade | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.extend | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.user | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.refund | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.callRefund | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.smsRefund | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.send | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.other | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.expense  | numFormat }}</span></td>
              </tr>
              <tr class="bg-warning">
                <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                <td class="text-center"><span class="text-blue">{{ avg.deposit  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.gift  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.affiliate  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.claim  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.receive  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.call | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.callPackage | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.cdp | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.invoicePlanOrder | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.email  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.sms | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.zns | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.aiChatbot | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.callTranscript | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.aiAgentToken | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.conversationEval | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.viber | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.oa | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.linePackage | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.ccuPackage | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.number | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.setup | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.brandName | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.brandNameRegister | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.new | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.newDivide | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.upgrade | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.extend  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.user  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.refund  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.callRefund  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.smsRefund  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.send  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.other  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.expense  | numFormat }}</span></td>
              </tr>
              <tr :key="index" v-for="(item, index) in data">
                <td style="min-width: 200px"><b>{{ label(item) }}</b></td>
                <td class="text-center"><span class="text-blue">{{ item.deposit | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.gift | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.affiliate | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.claim | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.receive | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.call | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.callPackage | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.cdp | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.invoicePlanOrder | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.email | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.sms  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.zns  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.aiChatbot  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.callTranscript  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.aiAgentToken  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.conversationEval  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.viber  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.oa  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.linePackage  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.ccuPackage  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.number  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.setup  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.brandName  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.brandNameRegister  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.new  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.newDivide  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.upgrade | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.extend | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.user  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.refund | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.callRefund | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.smsRefund | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.send | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.other | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.expense | numFormat }}</span></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="tile">
          <div class="row">
            <div class="col">
              <div>
                <apexchart :height="300" :options="chartOptions" :series="chartData"></apexchart>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="tile">
          <div class="table-responsive c-template-table">
            <table class="table table-hover table-bordered">
              <thead>
              <tr>
                <th></th>
                <th class="text-center">{{$t('emailCount')}}</th>
                <th class="text-center">{{$t('emailAmount')}}</th>
                <th class="text-center">{{$t('smsCount')}}</th>
                <th class="text-center">{{$t('smsAmount')}}</th>
                <th class="text-center">{{$t('znsCount')}}</th>
                <th class="text-center">{{$t('znsAmount')}}</th>
                <th class="text-center">{{$t('viberCount')}}</th>
                <th class="text-center">{{$t('viberAmount')}}</th>
                <th class="text-center">{{$t('oaCount')}}</th>
                <th class="text-center">{{$t('oaAmount')}}</th>
                <th class="text-center">{{$t('lineCount')}}</th>
                <th class="text-center">{{$t('lineAmount')}}</th>
              </tr>
              </thead>
              <tbody>
              <tr class="bg-success">
                <td><b class="text-uppercase">{{ $t('totals') }}</b></td>
                <td class="text-center"><span class="text-blue">{{ sum.emailCount | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.email | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.smsCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.sms  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.znsCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.zns  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.viberCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.viber  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.oaCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.oa  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.linePackageCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.linePackage  | numFormat }}</span></td>
              </tr>
              <tr class="bg-warning">
                <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                <td class="text-center"><span class="text-blue">{{ avg.emailCount | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.email | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.smsCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.sms  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.znsCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.zns  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.viberCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.viber  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.oaCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.oa  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.linePackageCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.linePackage  | numFormat }}</span></td>
              </tr>
              <tr :key="index" v-for="(item, index) in data">
                <td style="min-width: 200px"><b>{{ label(item) }}</b></td>
                <td class="text-center"><span class="text-blue">{{ item.emailCount | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.email | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.smsCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.sms  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.znsCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.zns  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.viberCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.viber  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.oaCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.oa  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.linePackageCount  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.linePackage  | numFormat }}</span></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import TimeRangePicker from "../../components/TimeRangePicker";
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts';
import ClientSelect from "../../components/ClientSelect";
import FinanceExport from "@/views/report/FinanceExport";
export default {
  props: ['client'],
  components: {FinanceExport, ClientSelect, TimeRangePicker, 'apexchart': VueApexCharts},
  data: function () {
    return {
      filterFormModel: {
        group: 'day',
        client: this.client ? this.client._id : null,
        isShorted: this.client ? true : null,
        source: null
      },
      loading: true,
      data: [],
      chartOptions: {
        xaxis: {},
        chart: {
          zoom: {
            enabled: false
          },
          type: 'line'
        }
      },
      chartData: [],
      sum: {},
      avg: {}
    }
  },
  methods: {
    load() {
      let loader = this.$loading.show();
      this.loading = true;
      this.filterFormModel.to = moment(this.filterFormModel.to, 'x').endOf('day').format('x');
      this.$service.get('/report/finance', {
        params: this.filterFormModel
      }).then(response => {
        this.data = response.data;
        this.sum = {};
        this.avg = {};
        this.data.forEach(item => {
          for (let key in item) {
            if (key !== 'label') {
              item[key] = Math.abs(item[key]);
              if (!this.sum[key]) {
                this.sum[key] = 0;
              }
              this.sum[key] += Math.abs(item[key]);
            }
          }
        });
        for (let key in this.sum) {
          this.avg[key] = Math.round(this.sum[key] / this.data.length);
        }
        this.chartOptions = {
          xaxis: {
            categories: this.data.map(d => this.label(d)).slice(0, 99).reverse(),
            labels: {
              rotate: 0
            },
            tooltip: {
              enabled: false,
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return new Intl.NumberFormat().format(value);
              }
            },
          },
          chart: {
            zoom: {
              enabled: false
            },
            type: this.filterFormModel.group === 'day' ? 'line' : 'bar'
          }
        };
        this.chartData = [
          {
            name: this.$t('deposit'),
            data: this.data.map(d => d.deposit).slice(0, 99).reverse(),
          },
          {
            name: this.$t('expense'),
            data: this.data.map(d => d.expense).slice(0, 99).reverse(),
          }
        ];
      }).finally(() => {
        loader.hide();
        this.loading = false;
      });
    },
    label(item) {
      if (item.label) {
        return item.label;
      }
      if (!isNaN(item._id)) {
        return moment(this.filterFormModel.from + item._id, 'x').format('DD/MM/YYYY');
      }
    },
    reset() {
      this.filterFormModel = {
        group: 'day',
        client: null,
        source: null,
        from: moment().startOf('month').toDate().getTime(),
        to: moment().endOf('month').toDate().getTime()
      };
      this.load()
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        finance: 'Finance Report',
        byDay: 'By day',
        byMonth: 'By month',
        byClient: 'By client',
        sum: 'Sum',
        avg: 'Average',
        overview: 'Overview',
        detail: 'Detail',
        deposit: "Deposit",
        gift: "Gift",
        claim: "Claim",
        receive: "Receive from other client",
        expense: "Expense",
        call: "Call fee",
        callPackage: "Package call fee",
        email: "Email",
        sms: "SMS",
        number: "Number",
        setup: "Number setup",
        brandName: "Brand name",
        brandNameRegister: "Brand name register",
        new: "New",
        newDivide: "New due to divided",
        upgrade: "Upgrade",
        extend: "Extend",
        user: "Additional user",
        refund: "Refund credit deposit",
        callRefund: "Refund of call charges",
        smsRefund: "SMS refund",
        send: "Send to other client",
        totals: "Total",
        average: "Average",
        moneyIn: "Money in",
        cdp: "CDP package",
        affiliate: "Affiliate",
        byPlan: "By plan",
        byCategory: "By category",
        emailCount: "Email count",
        emailAmount: "Email Revenue",
        smsCount: "Number of SMS",
        smsAmount: "SMS Revenue",
        znsCount: "Number of ZNS",
        znsAmount: "ZNS Revenue",
        viberCount: "Viber Count",
        viberAmount: "Viber Revenue",
        oaCount: "OA count",
        oaAmount: "OA revenue",
        sendOAMessage: "Send OA message",
        lineCount: "Line count",
        lineAmount: "Line revenue",
        ccuPackage: "Internal video calling",
        aiChatbot: "AI employee",
        financeAiAgentToken: "AI Agent tokens",
        financeConvEval: "AI conversation eval",
        financeOther: "Other",
        clientSource: "Client source",
        nature: "Nature",
        salesFound: "Sales found",
        invoicePlanOrder: "Electronic invoice service",
      },
      vi: {
        finance: 'Báo cáo tài chính',
        byDay: 'Theo ngày',
        byMonth: 'Theo tháng',
        byClient: 'Theo client',
        sum: 'Tổng',
        avg: 'Trung bình',
        overview: 'Tổng quan',
        detail: 'Chi tiết',
        deposit: "Nạp",
        gift: "Tặng",
        claim: "Bồi thường",
        receive: "Nhận từ client khác",
        expense: "Tiêu",
        call: "Cước gọi",
        callPackage: "Cước gọi theo gói",
        email: "Email",
        sms: "SMS",
        number: "Thuê số",
        setup: "Cài đặt số",
        brandName: "Duy trì brand name",
        brandNameRegister: "Đăng ký brand name",
        new: "Mua mới dịch vụ",
        newDivide: "Mua mới do tách domain",
        upgrade: "Nâng cấp",
        extend: "Gia hạn",
        user: "Mua thêm người dùng",
        refund: "Hoàn lệnh nạp tiền",
        callRefund: "Hoàn tiền cước gọi",
        smsRefund: "Hoàn tiền SMS",
        send: "Chuyển cho client khác",
        totals: "Tổng",
        average: "Trung bình",
        moneyIn: "Tiền vào",
        cdp: "Gói CDP",
        affiliate: "Giới thiệu",
        byPlan: "Theo gói dịch vụ",
        byCategory: "Theo ngành",
        emailCount: "Số lượng Email",
        emailAmount: "Doanh thu Email",
        smsCount: "Số lượng SMS",
        smsAmount: "Doanh thu SMS",
        znsCount: "Số lượng ZNS",
        znsAmount: "Doanh thu ZNS",
        viberCount: "Số lượng Viber",
        viberAmount: "Doanh thu Viber",
        oaCount: "Số lượng OA",
        oaAmount: "Doanh thu OA",
        sendOAMessage: "Gửi tin OA",
        lineCount: "Số lượng Line",
        lineAmount: "Doanh thu Line",
        ccuPackage: "Gọi video nội bộ",
        aiChatbot: "Nhân viên AI",
        financeAiAgentToken: "Token AI Agent",
        financeConvEval: "AI đánh giá hội thoại",
        financeOther: "Khác",
        clientSource: "Nguồn khách",
        nature: "Tự nhiên",
        salesFound: "NVKD tự tìm",
        invoicePlanOrder: "Dịch vụ hoá đơn điện tử",
      }
    }
  }
}
</script>
